<template>
    <div>
        <!--  Change Password Form  -->
        <section class="container-fluid stepsBar">
            <div class="container mt-5">
            <div class="whiteBgContent">
                <h1 class="mb-4 text-center">My Order</h1>

                <h2 class="mb-3">Order Status</h2>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">How long will it take for my order to be accepted?</h3>
                    <p>An order will be processed within 48 hours of placement. You will receive a   confirmation email following order placement containing information such as ordering details and an estimated shipping date.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">What is the status of my order? </h3>
                    <p>You can find the status of your order at any time by checking the “My Order” tab on your WeVisu dashboard.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">What happens after I place my order? </h3>
                    <p>After your order has been placed, you will receive an order confirmation via email.  A second email will be sent once your order has been shipped. This second email will contain tracking details.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">How can I contact a merchant about my order?</h3>
                    <p>The WeVisu support team will be happy to assist in providing vendor information and contact details. You can reach the WeVisu support team via email at <a href="mailto:ciinfo@wevisu.com">ciinfo@wevisu.com</a>. Please make sure to include your confirmation order number when contacting. </p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">Where can I find my order history?</h3>
                    <p>You can view your order history under the “My Order” tab on your WeVisu     dashboard.</p>
                </div>
                

                <h2 class="mb-3">Add/Edit Order</h2>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">Can I make changes to my order after it's been placed?</h3>
                    <p>If you need to make changes to your order, please contact the customer support team at <a href="mailto:ciinfo@wevisu.com">ciinfo@wevisu.com</a> immediately. Delaying this process can result in issues with your order.</p>
                </div>

                
                

            </div>  
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Your_orders",
    components: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    },

    created() {

    }
}

</script>
